import IApplicationRequest from "./IApplicationRequest";
import IFinancedSubjectBase from "@/module/main/dto/IFinancedSubjectBase";
import IOriginationContextRequest from "@/module/main/dto/IOriginationContextRequest";
import ICustomer from "./ICustomer";

export default class ApplicationRequest implements IApplicationRequest
{
    public readonly financedSubject: IFinancedSubjectBase;
    public readonly originationContext: IOriginationContextRequest;
    public readonly customer?: ICustomer;

    constructor(props: IApplicationRequest)
    {
        this.financedSubject = props.financedSubject;
        this.originationContext = props.originationContext;
        this.customer = props.customer;
    }
}
